import { styled } from "@mui/material/styles";
import NativeSelect from "@mui/material/NativeSelect";
import TextField from "@mui/material/TextField";

const Root = styled("div")(({ theme }) => ({
  textAlign: "center",
  padding: "50px",
  margin: "0px 100px",
  [theme.breakpoints.down("md")]: {
    padding: "20px",
    margin: "0px 10px",
  },
}));
const Tittle = styled("p")(({ theme }) => ({
  color: "#FF0000",
  padding: "35px 0px 0px 0px",
  fontWeight: "bold",
  fontSize: "2.5rem",
  [theme.breakpoints.down("sm")]: {
    fontSize: "2rem",
  },
}));
const Container = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    padding: "8px",
  },
}));
const Column = styled("div")(({ theme }) => ({
  margin: "auto",
  marginBottom: "30px",
  borderRadius: "20px",
  //   minHeight: "550px",
  padding: "15px",
  width: "100%",
  maxWidth: "550px",
  //   background: "#F3F3F3",
  [theme.breakpoints.down("sm")]: {
    // minHeight: "500px",
  },
}));
const Button = styled("button")((props) => ({
  width: "100%",
  backgroundColor: "#FF0000",
  textAlign: "center",
  padding: "15px",
  borderRadius: "15px",
  border: "0px",
  color: "white",
  maxWidth: "25rem",
  "&:hover": {
    backgroundColor: "#ffcdd2",
    opacity: [0.9, 0.8, 0.7],
    color: "black",
  },
  "&:focus": {
    outline: "0 !important",
  },
}));
const Helper = styled("p")((props) => ({
  textAlign: "center",
  paddingBottom: "15px",
  color: "#FF0000",
}));

const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "black",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "green",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "gray",
    },
    "&:hover fieldset": {
      borderColor: "gray",
    },
    "&.Mui-focused fieldset": {
      borderColor: "gray",
    },
  },
});

const CssNativeSelect = styled(NativeSelect)({
  "& .MuiNativeSelect-select": {
    textAlign: "center",
    paddingTop: "12px",
  },
});
const OptionSelect = styled("option")(({ theme }) => ({
  color: "black",
  background: "white",
  display: "flex",
  whiteSpace: "pre",
  minHeight: "20px",
  textAlign: "center",
  fontSize: "18px",
}));
const ButtonUpload = styled("button")(({ theme }) => ({
  // marginTop: "35px",
  width: "100%",
  backgroundColor: "#ffe3e3",
  textAlign: "center",
  padding: "15px",
  borderRadius: "15px",
  borderWidth: "1px",
  color: "black",
  minHeight: "82.5px",
  // backgroundColor: "#FF0000",
  "&:hover:enabled": {
    backgroundColor: "#FF0000",
    opacity: [0.9, 0.8, 0.7],
    color: "white",
  },
  "&:disabled": {
    backgroundColor: "#E9E9E9",
    opacity: [0.9, 0.8, 0.7],
    color: "white",
  },
}));

const stylesCss = {
  root: {
    "& .MuiStepIcon-root.Mui-active": { color: "red" },
    "& .MuiStepIcon-root.Mui-completed": { color: "#FF0000" },
    "& .Mui-disabled .MuiStepIcon-root": { color: "#ffcdd2" },
    // ["@media (min-width:420px)"]: {
    //   flexDirection: "column",
    // },
  },
  card: {
    textAlign: "center",
  },
  radioGroup: {
    alignItems: "center",
  },
  radio: {
    color: "#FF0000",
    "&.Mui-checked": {
      color: "#FF0000",
    },
  },
  btnBuscarRegresar: {
    backgroundColor: "red",
    borderRadius: "13px",
    height: "60px",
    padding: "15px 30px 15px 30px",
    "&:hover": {
      backgroundColor: "#ffcdd2",
      opacity: [0.9, 0.8, 0.7],
      color: "black",
    },
  },
  gridBtnContinuar: {
    textAlign: "left",
  },
};

export default stylesCss;
export {
  Root,
  Tittle,
  Container,
  Column,
  Button,
  Helper,
  CssNativeSelect,
  OptionSelect,
  CssTextField,
  ButtonUpload,
};
